import endpointDefinition from "../../../internals/api/site/get_site_info.json";
import { AjaxAction } from "@npm_leadtech/jsr-lib-http/dist/esm/index";

export class GetSiteInfoAction extends AjaxAction {
  constructor(endpointService) {
    super(endpointService, endpointDefinition);
  }
}
